import * as React from 'react';
import Intro from 'components/intro';
import Gretting from 'components/greeting';
import Gallery from 'components/gallery';
import Location from 'components/location';
import Gift from 'components/gift';

interface Iprops {
  messages: any;
}

const Home = (props: Iprops) => {
  return (
    <>
      <Intro {...props}/>
      <Gretting  {...props}/>
      <Gallery  {...props}/>
      <Location  {...props}/>
      <Gift {...props}/>
    </>
  )
}

// class App extends React.Component<Iprops> {
//   public render() {
//     return (
//       <React.Fragment>
//         <Intro {...this.props}/>
//         <Gretting  {...this.props}/>
//         <Location  {...this.props}/>
//       </React.Fragment>
//     );
//   }
// }

export default Home;


// WEBPACK FOOTER //
// ./src/pages/index.tsx